<template>

    <v-panel title="Logo">
        <v-section name="Image" expanded>
            <v-action-image />
            <v-action-alt />
        </v-section>
        <v-section name="Link">
            <v-action-text type="link" />
        </v-section>
        <v-section name="Size &amp; Position">
            <v-action-align :container="true" />
            <v-action-size type="max-height" />
        </v-section>
        <v-section-block />
    </v-panel>

</template>

<script>

import ActionAlign from './actions/ActionAlign';
import ActionAlt from './actions/ActionAlt';
import ActionImage from './actions/ActionImage';
import ActionSize from './actions/ActionSize';
import ActionText from './actions/ActionText';
import Panel from './Panel';
import Section from './sections/Section';
import SectionBlock from './sections/SectionBlock';

export default {

    components: {
        'v-action-align': ActionAlign,
        'v-action-alt': ActionAlt,
        'v-action-image': ActionImage,
        'v-action-size': ActionSize,
        'v-action-text': ActionText,
        'v-panel': Panel,
        'v-section': Section,
        'v-section-block': SectionBlock,
    },

}

</script>